<script setup>

</script>

<template>
    <section class="hero tw-h-[759px] tw-flex tw-items-end tw-justify-start">
        <div class="tw-w-2/3 tw-mx-auto tw-py-24">
            <slot />
        </div>
    </section>
</template>

<style lang="scss" scoped>
/* TODO: create props for this */
$height: 389px;
$width: 688px;
$triangle: polygon(100% 0, 0 100%, 100% 100%);

.hero {
    background: center url('../__clients/ezi/hero-images/plans-and-pricing.png') no-repeat;
    background-size: cover;
    position: relative;

    &:before, &:after {
        content: '';
        position: absolute;
        bottom: 0;
        right: 0;
        clip-path: $triangle;
    }

    &:before {
        height: $height;
        width: $width;
        background: linear-gradient(59.77deg, #FF0090 1.18%, #FF7D90 94.11%);
    }

    &:after {
        height: $height * 2.5;
        width: $width * 2.5;
        background: linear-gradient(124.04deg, rgba(255, 255, 255, 0.15) 45.88%, rgba(255, 255, 255, 0.075) 72.13%);
    }
}

</style>